import {MY_PATIENTS_ROUTE} from "../../../routes";
import {useNavigate} from "react-router";
import {useEffect} from "react";
import {clearSavedListParams} from "../../../helpers/LocalStorageHelper";

export function MyPatientsClear() {
    const history = useNavigate()
    useEffect(() => {
        clearSavedListParams();
        history(MY_PATIENTS_ROUTE, {replace: true});
    }, []);
    return <div/>
}